import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeleguesService {
  module = environment.webService.server + environment.webService.url + environment.webService.api;

  constructor(private http: HttpClient) {}

  //Récupérer la liste paginée des délégations
  getDeleguesAgent(id: number) {
    const params = new HttpParams().set('remplace.id', '' + id);
    return this.http.get<any>(this.module + '/agents/delegues', { params });
  }
  //Renvoie la liste paginée des délégations de l'utilisateur connecté
  getMesDelegues() {
    return this.http.get<any>(this.module + '/agents/mes-delegues');
  }

  //Créer une délégation pour l'utilisateur
  AjoutDelegue(model: any) {
    return this.http.post<any>(this.module + '/agents/delegues', model);
  }
  //Créer une délégation pour l'utilisateur connecté
  AjoutMonDelegue(model: any) {
    return this.http.post<any>(this.module + '/agents/mes-delegues', model);
  }

  //Mettre à jour la délégataion
  modifierDelegue(data: any, id: number) {
    return this.http.put<any>(this.module + '/agents/delegues/' + id, data);
  }

  // Mettre à jour la délégation pour l'utilisateur connecté
  modifierMonDelegue(data: any, id: number) {
    return this.http.put<any>(this.module + '/agents/mes-delegues/' + id, data);
  }

  getDeleguesWithParams(offset: number, limit: number, id: number, filtre: string | null = null) {
    filtre = filtre ?? '';
    let url = this.module + '/agents/delegues';
    if (filtre != '' && filtre !== undefined && filtre !== null) {
      url = url + '?' + `filterGenerique=${filtre}`;
    }

    const params = new HttpParams().set('page', offset).set('size', limit);

    if (id) {
      params.set('remplace.id', '' + id);
    }
    return this.http.get<any>(url, { params });
  }

  supprimerDelegue(id: number) {

    return this.http.delete<any>(this.module + '/agents/delegues/' + id);
  }
  //Supprimer délégation pour le user connecté
  supprimerMonDelegue(id: number) {
    return this.http.delete<any>(this.module + '/agents/mes-delegues/' + id);
  }
}
